<template>
  <q-card flat>
    <q-card-section>
      <div class="row">
        <div class="col-xs-12">
          <div class="inset-card-title q-pb-md">
            Email template
          </div>
          <div class="no-padding">
            <EmailEditor
              :model-subject="template.subject"
              :model-content="template.body"
              :merge-tags="template.merge_tags"
              hide-labels
              @subject-input="updateTemplate('subject', $event)"
              @content-input="updateTemplate('body', $event)"
            />
          </div>
        </div>
        <div class="col-xs-12">
          <q-card flat class="q-mb-md">
            <q-card-section class="no-padding-left">
              <div class="inset-card-title">
                Attachments
              </div>
              <div class="q-mt-md">
                <email-attachments ref="emailAttachments" @attachments-updated="$emit('attachments', $event)" />
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
// Components
import EmailEditor from '@components/editors/EmailEditor'
import EmailAttachments from '@/components/lm-blocks/EmailAttachments'

export default {
  components: {
    EmailEditor,
    EmailAttachments
  },

  props: {
    template: Object
  },

  methods: {
    updateTemplate(prop, newValue) {
      let template = _cloneDeep(this.template)
      template[prop] = newValue
      this.$emit('update:template', template)
    },
    resetEmailAttachments() {
      this.$refs.emailAttachments.resetEmailAttachments()
    }
  }
}
</script>
